import FirebaseHandler from "../../firebase";
import { httpsCallable } from "firebase/functions";
export const magazineAccess = (magazineNumber, magazineFile) => {
    const magazineAccess = httpsCallable(FirebaseHandler.functions, "magazineAccess");
    return magazineAccess({
        magazineNumber: magazineNumber,
        magazineFile: magazineFile
    });
};
